import React from 'react';

const SLATE = '#0B1426';
const CORAL = '#FF4E6A';
const MUTED = '#5B6577';
const RULE  = 'rgba(11,20,38,0.10)';

/* Lightweight horizontal KPI row used at the top of the AG reviewer and
 * Hale decisions consoles. Cards are computed-from-queue so they don't
 * require a new backend endpoint and stay in sync with the visible list. */
export default function SummaryCards({ items, accent = CORAL, testidPrefix = 'summary' }) {
  return (
    <div
      className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8"
      data-testid={`${testidPrefix}-row`}
    >
      {items.map(({ key, label, value, tone }) => (
        <div
          key={key}
          className="rounded-sm border p-4"
          style={{ borderColor: RULE, backgroundColor: 'rgba(255,255,255,0.6)' }}
          data-testid={`${testidPrefix}-${key}`}
        >
          <p
            className="text-[10px] font-mono uppercase tracking-[0.22em] mb-2"
            style={{ color: MUTED }}
          >
            {label}
          </p>
          <p
            className="text-3xl font-extrabold tabular-nums leading-none"
            style={{ fontFamily: '"Cormorant Garamond", serif', color: SLATE }}
          >
            {value}
          </p>
          <span
            className="inline-block mt-3 h-[2px] w-8"
            style={{ backgroundColor: tone || accent }}
          />
        </div>
      ))}
    </div>
  );
}
